import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import AccountList from './components/AccountList.vue'
import TaskDetail from './components/TaskDetail.vue'
import TaskList from './components/TaskList.vue'

const routes = [
  { path: '/', component: AccountList },
  { path: '/account/:id/tasks', component: TaskList },
  { path: '/account/:id/task/:taskId', component: TaskDetail }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

const app = createApp(App)
app.use(router)
app.mount('#app')
